import { InlineInfoMessage } from '../../../../shared/shared-transfer-list-new';
import { BulkOpSourceType, SourceTypeOption } from './source-type-options';
import BulkOpTag from './bulk-op-tag';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import EventNoteOutlined from '@mui/icons-material/EventNoteOutlined';
import Groups from '@mui/icons-material/Groups';
import Lan from '@mui/icons-material/Lan';
import Person from '@mui/icons-material/Person';
import Settings from '@mui/icons-material/Settings';

const SOURCE_TYPE_ICONS = {
  User: Person,
  Group: Groups,
  OrgUnit: Lan,
  Domain: EventNoteOutlined,
  gPanel_Role: Settings,
};

interface SourceTypeSelectorProps {
  options: SourceTypeOption[];
  value: string | null;
  onChange: (value: BulkOpSourceType) => void;
  hasSources: boolean;
  allSource: boolean;
}

export default function SourceTypeSelector({
  options,
  value,
  onChange,
  hasSources,
  allSource,
}: SourceTypeSelectorProps) {
  const theme = useTheme();
  const applicable = options.filter((option) => !option.notApplicable);

  return (
    <Stack>
      <Stack direction="row" alignItems="center" gap={1} sx={{ py: 1 }}>
        <Typography
          variant="body1"
          sx={{ color: theme.palette.semantic.text.title2 }}
        >
          Source type:
        </Typography>
        {applicable.length === 1 ? (
          <BulkOpTag
            label={applicable[0].label}
            icon={SOURCE_TYPE_ICONS[applicable[0].value]}
          />
        ) : (
          <RadioGroup
            row
            aria-label="Source type"
            value={value}
            onChange={(e) => onChange(e.target.value as BulkOpSourceType)}
          >
            {applicable.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                disabled={(hasSources || allSource) && option.value !== value}
              />
            ))}
          </RadioGroup>
        )}
      </Stack>
      {hasSources && applicable.length > 1 && (
        <InlineInfoMessage variant="body1">
          Only one source type is allowed
        </InlineInfoMessage>
      )}
    </Stack>
  );
}
